import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'conta-receber', ptBr);
i18next.addResourceBundle('en', 'conta-receber', en);

const ContaReceberConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/financeiro/conta-receber',
      component: React.lazy(() => import('./ContaReceber')),
    },
  ],
};

export default ContaReceberConfig;
